import get from './methods/get';

export default class Dadata {
    token = '49c7101dc8ea90040836b1054c2f931570716c2f';
    url = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';

    get = get;
}
